
import { throwError as observableThrowError, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';

@Injectable()
export class DataSourcesService {
    constructor(private http: Http) { }

    getDataSources(country: string, provstate: string) {
        let url = `${environment.api.serviceurl}` + "GetDataSource?country=" + country + "&provstate=" + provstate;
        return this.http.get(url).pipe(
            map((response: Response) => {

                let projectInfo = response.json();
                let t = projectInfo.GetDataSourceResult;
                let p = ('(' + t + ')');

                let s = eval(p);
                return s;
            }));
    }

    getdataSources(customerId: string, country: string, provState: string, sKey: string): Observable<any> {
        let url = `${environment.api.serviceurl}` + "getDataSource";
        let orderData = { "customerid": customerId, "country": country, "provstate": provState };
        let headers = new Headers();
        headers.set('Content-Type', 'application/json');
        headers.set("authinfo", sKey);
        let data = JSON.stringify(orderData);
        let options = new RequestOptions({ headers: headers });
        return this.http.post(url, data, options).pipe(
            map(this.extractData),
            catchError(this.handleError),);
    }

    private extractData(res: Response) {
        let body = res.json();
        if (body.status == "OK") {
            let jsonbody = JSON.parse(body.orderid);
            return jsonbody || {};
        } else {
            observableThrowError(body.message);
            return []
        }
    }

    private handleError(error: any) {
        let errMsg = '';
        if (error.message) {
            errMsg = error.message;
        } else {
            errMsg = error.status ? '${error.status} - ${error.statusText}' : 'Server error';
        }
        return observableThrowError(errMsg);
    }
}